const getUrlPaths = (ids: string | string[], extraUrl: string | undefined) => {
  if (Array.isArray(ids))
    return ids.map((id: string) => (extraUrl ? `${id}${extraUrl}` : id));

  return [extraUrl ? `${ids}${extraUrl}` : ids];
};

export default getUrlPaths;
